import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '@/theme/scalingTokens';

export const useSectionCardStyles = makeStyles({
  root: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('16px'),
    ...shorthands.padding('16px'),
    boxShadow: tokens.shadow4,
    [mq.mobile]: {
      ...shorthands.padding('12px'),
      ...shorthands.borderRadius('12px'),
    },
  },
  /**
   * Figma 2026 SectionCard (used in Review and Confirmation): white surface,
   * neutral 1 px border, 8 px radius, no shadow.
   */
  rootFigma: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRadius('0.5rem'),
    ...shorthands.padding(tokens.spacingHorizontalL),
    boxShadow: 'none',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('12px'),
    marginBottom: '12px',
  },
  headerAction: {
    marginLeft: 'auto',
    flexShrink: 0,
  },
  icon: {
    color: tokens.colorBrandForeground1,
    flexShrink: 0,
    width: '16px',
    height: '16px',
  },
  title: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
    margin: '0',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('12px'),
  },
});
